import { backendClient } from '@/lib/backendClient';

/**
 * DEPRECATED: This function is deprecated and should not be used.
 * The new referral system uses referral_code_id instead of the legacy referral_code field.
 * Use the backend /auth/register endpoint with referral_code_id parameter instead.
 *
 * @deprecated Use backend /auth/register with referral_code_id instead
 * @param userId The user ID to process
 * @param referralCode The referral code used (optional)
 */
export const processReferralSignup = async (userId: string, referralCode?: string) => {
  console.warn('processReferralSignup is deprecated. Use backend /auth/register endpoint with referral_code_id instead.');
  return;
};

export const getReferralCodeFromUrl = (): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('ref');
};

export const clearReferralCodeFromUrl = () => {
  const url = new URL(window.location.href);
  url.searchParams.delete('ref');
  window.history.replaceState({}, document.title, url.toString());
};